// Fichier : Tabs.tsx
// Ce fichier définit le composant Tabs qui utilise useGetTabsQuery pour récupérer les Tabs depuis l'API et affiche ensuite la table des Tabs à l'aide de Mantine Table.

import { useGetTabsQuery } from "@/state/usersApiSlice";
import Table from "./Table";
import styles from "./Tabs.module.css";
import { useNavigate } from "react-router-dom";

const Tabs = () => {
  const { data: tabs } = useGetTabsQuery(); // Utilisation de useGetTabsQuery pour récupérer les données des Tabs depuis l'API
  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <button
          className={styles.addbutton}
          onClick={() => navigate("/tabs/add")}
        >
          Create Tab
        </button>
        {tabs && <Table tabs={tabs} />}
        {/* Affichage de la table des Tabs si les données sont disponibles */}
      </div>
    </div>
  );
};

export default Tabs;
